"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactBootstrap = require("react-bootstrap");

var LoadingScreen = function LoadingScreen() {
  var middle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  };
  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      style: middle
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Card, {
      className: "text-center mt-2"
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Card.Body, null,
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Card.Title, null,
    /*#__PURE__*/
    _react["default"].createElement("h2", null, "Loading document"),
    /*#__PURE__*/
    _react["default"].createElement("hr", null),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "text-center"
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Spinner, {
      animation: "grow",
      variant: "info",
      "data-cy": "spinner"
    }))),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Card.Text, null, "This may take a minute"))))
  );
};

var _default = exports["default"] = LoadingScreen;